module.exports = "https://static.energy5.com/_next/static/images/rightTopGridAboutImage-32c975f1e3c6194bf3c576f40a4b522e.jpg";